import '../css/info-sidebar.css';
import '../css/info-docs-viewer.css';

import { IMAGE_VIEWER_PREFIX, LINK_SVG } from './info.details';

import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';

export default class InfoSidebar {
	constructor() {
		this.sidebar = document.getElementById('info-sidebar');
		this.cityName = document.getElementById('info-sidebar-city');
		this.areaValue = document.getElementById('info-sidebar-area-value');
		this.populationValue = document.getElementById('info-sidebar-population-value');
		this.housesValue = document.getElementById('info-sidebar-houses-value');
		this.docs = document.getElementById('info-sidebar-docs');
		this.docsViewer = document.getElementById('info-docs-viewer-wrapper');
		this.docsViewerImage = document.getElementById('info-docs-image');
		this.currentDocIndex = 0;
		this.currentDocs = [];
	}

	init() {
		this.setupHeadings();
		this.setupDocsViewerClose();
	}

	setupDocsViewerClose() {
		const closeBtn = document.getElementById('info-docs-close-btn');
		if (!closeBtn || !this.docsViewer) return;
		this.docsViewer.onclick = (event) => {
			if (!this.docsViewer) return;
			if (event.target !== this.docsViewer) return;
			this.docsViewer?.classList.remove('active');
		};
		closeBtn.onclick = () => {
			this.docsViewer?.classList.remove('active');
		};
	}

	setupHeadings() {
		const headingDetails = document.getElementById('info-sidebar-heading-details');
		const headingDocs = document.getElementById('info-sidebar-heading-docs');
		if (!headingDetails || !headingDocs) return;
		headingDetails.onclick = () => {
			if (this.sidebar) this.sidebar.dataset.state = 'details';
		};
		headingDocs.onclick = () => {
			if (this.sidebar) this.sidebar.dataset.state = 'docs';
		};
	}

	update(items = []) {
		if (!items.length) {
			this.sidebar?.classList.remove('active');
			return;
		}
		const firstItem = items[0];
		this.updateDetails(firstItem);
		this.updateDocs(firstItem.docs);
		this.sidebar?.classList.add('active');
		if (this.sidebar) this.sidebar.dataset.state = 'details';
	}

	updateDocs(docs) {
		if (!this.docs || !docs) return;
		if (this.docsScrollbars && OverlayScrollbars.valid(this.docsScrollbars)) {
			this.docsScrollbars.destroy();
			this.docsScrollbars = null;
		}
		this.docs.innerHTML = '';
		this.currentDocs = docs;
		this.currentDocIndex = 0;

		const fragment = new DocumentFragment();
		let index = 0;
		for (const doc of docs) {
			const element = this.getDocElement(doc, docs, index);
			fragment.appendChild(element);
			index++;
		}
		this.docs.appendChild(fragment);

		setTimeout(() => {
			this.docsScrollbars = OverlayScrollbars(this.docs, {
				overflow: {
					x: 'hidden',
					y: 'scroll'
				}
			});
		});
	}

	getDocElement(doc, docs, index) {
		const element = document.createElement('div');
		element.classList.add('info-sidebar-doc-element');
		const thumbnail = document.createElement('div');
		thumbnail.classList.add('info-sidebar-doc-thumbnail');
		const docUrl = this.getDocUrl(doc);
		if (docUrl) thumbnail.style.backgroundImage = `url('${docUrl}')`;
		const label = document.createElement('div');
		label.classList.add('info-sidebar-doc-label');
		const labelContent = document.createElement('span');
		labelContent.textContent = doc['Tartalmazza'] || 'N/A';
		label.appendChild(labelContent);
		const path = doc['Adatlap'] || '';
		if (path) {
			const a = document.createElement('a');
			a.href = IMAGE_VIEWER_PREFIX + '/' + path;
			a.target = '_blank';
			a.classList.add('info-sidebar-doc-link');
			a.innerHTML = LINK_SVG;
			label.appendChild(a);
		}
		element.appendChild(thumbnail);
		element.appendChild(label);
		thumbnail.onclick = () => {
			this.showDocsViewer(docs, index);
		};
		return element;
	}

	getDocUrl(doc) {
		const rawLocation = (doc['Őrzési hely (Levéltár) neve'] || '').trim();
		const rawCity = (doc['Korabeli település neve'] || '').trim();
		const subjectId = (doc['SUBJECT ID'] || '').toString().trim();
		const rawFilename = (doc['Új fájlnév'] || '').trim();
		if (!rawLocation || !rawCity || !subjectId || !rawFilename) return null;
		const filename = rawFilename.endsWith('.jpg') ? rawFilename : `${rawFilename}.jpg`;
		const path = `thumb/${filename}`;
		return encodeURI(path); // will produce ...Zalaszentiva%CC%81n_69717/...
	}

	showDocsViewer(docs = this.currentDocs, index = this.currentDocIndex) {
		this.docsViewer?.classList.add('active');

		if (!docs || !docs.length) return;
		if (index < 0 || index >= docs.length) return;

		const doc = docs[index];
		if (!doc || !this.docsViewerImage) return;

		const path = doc['Képnézegető'] || '';
		if (!path) return;

		const url = IMAGE_VIEWER_PREFIX + path;

		this.docsViewerImage.src = url;
		this.currentDocIndex = index;
	}

	updateDetails(firstItem) {
		if (!this.cityName || !this.areaValue || !this.populationValue || !this.housesValue) return;
		this.cityName.textContent = 'N/A';
		this.areaValue.textContent = 'N/A';
		this.populationValue.textContent = 'N/A';
		this.housesValue.textContent = 'N/A';
		if (!firstItem) return;
		this.cityName.textContent = firstItem['A település mai neve'] || 'N/A';
		this.areaValue.textContent = firstItem['A település korabeli területe (katasztrális holdban)'] || 'N/A';
		this.populationValue.textContent = firstItem['A település korabeli lakossága (fő)'] || 'N/A';
		this.housesValue.textContent = firstItem['A település házainak száma'] || 'N/A';
	}
}
